var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisableToggleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6C1.5 3.49254 3.43463 1.5 5.77273 1.5H11.2273C13.5654 1.5 15.5 3.49254 15.5 6C15.5 8.50746 13.5654 10.5 11.2273 10.5H5.77273C3.43463 10.5 1.5 8.50746 1.5 6ZM5.77273 0.5C2.83902 0.5 0.5 2.98461 0.5 6C0.5 9.01539 2.83902 11.5 5.77273 11.5H11.2273C14.161 11.5 16.5 9.01539 16.5 6C16.5 2.98461 14.161 0.5 11.2273 0.5H5.77273ZM11 3.5C9.61929 3.5 8.5 4.61929 8.5 6C8.5 7.38071 9.61929 8.5 11 8.5C12.3807 8.5 13.5 7.38071 13.5 6C13.5 4.61929 12.3807 3.5 11 3.5Z",
    fill: "#b3b1ab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableToggleIcon);
export default __webpack_public_path__ + "static/media/disableToggleIcon.9ca8b666833785601e5852478d3f18f9.svg";
export { ForwardRef as ReactComponent };